// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2bmYy","topBottomGutter":"Layout_topBottomGutter__2IG8v"};